import React from "react";
import clsx from "clsx";
import fp from "lodash/fp";
import { useFormContext } from "react-hook-form";

import { ReactComponent as WarningIcon } from "static/images/warning-alert.svg";
import styles from "./fields.module.scss";

export type ErrorMessageProps = {
	field: string;
	customStyles?: string;
	canShowErrorIcon?: boolean;
	errors?: any;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
	field,
	errors,
	customStyles,
	canShowErrorIcon = false,
}) => {
	const formMethods = useFormContext();
	errors = errors || formMethods?.formState.errors;

	const error = () => {
		if (!errors) return null;
		if (typeof errors.message === "string") return errors;
		return fp.get(field, errors);
	};
	return error() ? (
		<div className={clsx("errorMessage", customStyles)}>
			{canShowErrorIcon && (
				<WarningIcon className={styles.warningErrorIcon} />
			)}
			{error().message}
		</div>
	) : null;
};
